module.exports = __webpack_public_path__ + "static/media/menu-bg.45ad4fc4.jpg";